module.exports = __webpack_public_path__ + "img/sequire-pr.b15d23a9.png";